"use strict";

exports.__esModule = true;
exports.default = void 0;
var _ = require("./");
var _default = exports.default = {
  list: {
    path: "ssoauth",
    //icon: 'info',
    title: "SSO Auth",
    private: false,
    restricted: "",
    //level: 0,
    component: _.SSOAuth
  }
};
module.exports = exports.default;